module.exports = __webpack_public_path__ + "img/gb6170-86-m6.prt.81084628.jpg";